import React from 'react';
import Col from '../components/Grid/Col';
import Row from '../components/Grid/Row';
import Logo from '../components/Logo';
import Menu from '../components/Menu';
import RevealOnScroll from '../components/RevealOnScroll';

const Header = () => (
  <header className="container-xl w-full overflow-hidden">
    <RevealOnScroll>
      <Row md={3} className="py-16">
        <Col>
          <Logo className="h-12" />
        </Col>
        <Col md={2} className="hidden md:block text-right">
          <Menu />
        </Col>
      </Row>
    </RevealOnScroll>
  </header>
);

export default Header;
